module.exports = __webpack_public_path__ + "static/media/1009383.e10b463e.png";